import React, { useState } from "react";
import { FaSun, FaMoon } from "react-icons/fa";
import "./blogs.css";
import blog1 from "../assets/blog3-1.png";
import blog2 from "../assets/blog3-2.png";
function Blog3() {
  const [darkMode, setDarkMode] = useState(false);

  const toggleMode = () => {
    setDarkMode(!darkMode);
  };
  return (
    <div className={`base-blog1 ${darkMode ? "dark" : "light"}`}>
      <div id="head-toggle-blog">
        <h1
          style={{
            textTransform: "initial",
            textDecoration: "underline",
            marginTop: "20px",
          }}
        >
          Journey of TTC - How to stay positive
        </h1>
        <div className="toggle-contents">
          <div
            className={`toggle-container ${darkMode ? "dark" : "light"}`}
            onClick={toggleMode}
          >
            <div className={`toggle-circle ${darkMode ? "dark" : "light"}`}>
              {darkMode ? (
                <FaMoon className="icon-blog moon" />
              ) : (
                <FaSun className="icon-blog sun" />
              )}
            </div>
          </div>
        </div>
      </div>
      <div id="blog-page-static">
        <p style={{ lineHeight: "1.5" }}>
          Trying to conceive can feel like an emotional rollercoaster, one
          minute you’re feeling hopeful, the next, you’re staring at an empty
          pregnancy test. For couples, this process can be a mixture of
          excitement, stress, and at times, overwhelming pressure. When that
          second line doesn’t appear when you’re hoping for it, it’s natural to
          feel a bit let down.
        </p>

        <div style={{ padding: "10px 0px" }}>
          <p style={{ lineHeight: "1.5" }}>
            But here’s the thing, the journey of TTC is so much more than the
            outcome. Sure, the end goal is pregnancy, but what happens in
            between is often where the real growth occurs. The highs, the lows,
            the lessons, and the moments of connection with your partner, it’s
            more about the process than the result.
          </p>
        </div>
        <div style={{ padding: "0px 0px 10px 0px" }}>
          <p style={{ lineHeight: "1.5" }}>
            So, if that test isn’t showing up as expected, don’t worry. It’s
            okay to take a step back and let things happen at their own pace.
            After all, life doesn’t follow a schedule, and sometimes the best
            things come when you least expect them.
          </p>
        </div>
      </div>

      <div className="flexie-blog">
        <div style={{ position: "relative" }}>
          <img src={blog1} alt="blog1-1st image" className="blog1-1" />
        </div>
        <div style={{ textAlign: "justify" }} id="right-image-cont">
          <h3>Great Things take time!!!</h3>
          <p>
            The constant pressure of waiting for that magical second line on the
            pregnancy test can be mentally exhausting. It’s easy to get caught
            up especially when the journey is taking longer than you expected.
            But here's something that many don’t talk about enough; Trying to
            conceive is more than just the goal of getting pregnant—it’s about
            learning to navigate the unpredictability of life, embracing
            patience, and finding strength in vulnerability.
          </p>
          <h3>Society’s Pressure:</h3>
          <p>
            When society’s clock is ticking louder than your own, it’s hard not
            to feel pressured. Family members, friends, and even well-meaning
            strangers may ask questions like, “So, when are you having kids?” or
            “Don’t wait too long!” This only adds fuel to the fire, making it
            even harder to maintain your sense of calm. You may find yourself
            comparing your timeline to others, which can create unnecessary
            stress. But the truth is, everyone’s journey is different, and
            there’s no right timeline to follow.
          </p>
          <p>
            TTC is often full of unexpected turns like cycle irregularities,
            health challenges, or even a simple delay in ovulation. These
            hurdles aren’t always in your control. What is in your control,
            however, is how you respond. And trust me, it’s okay to not always
            have it together. It’s okay to feel frustrated. It’s okay to give
            yourself grace. Your body knows what it’s doing, even if it’s taking
            its time.
          </p>
        </div>
      </div>
      <div className="flxie-blog1">
        <div style={{ textAlign: "justify" }} id="right-image-cont">
          <h3>
            Take a step back and relax; let things unfold at their own pace.
          </h3>
          <p>
            Allowing yourself to step back from the hurry of it all can make a
            world of difference. Instead of obsessing over counting days, try
            focusing on enjoying the present moment with your partner. This is a
            journey that you’re taking together, and there’s beauty in the
            shared experience of it.
          </p>
          <p>
            Take time for yourself, whether that means indulging in a favourite
            hobby, getting outside for fresh air, or just taking a mental break
            from the TTC grind. Take care of your mental health, because the
            emotional toll can be just as exhausting as the physical one.
          </p>
          <p>
            Ultimately, the journey of trying to conceive is as much about
            self-discovery as it is about the pursuit of parenthood. The
            emotional highs and lows will test your patience, but they’ll also
            reveal the depth of your resilience and the strength of your bond
            with your partner. And when the time finally comes and you do see
            those two lines on the pregnancy test, you'll realise that
            everything—the waiting, the hope, the tears, the joy—was worth it.
          </p>
        </div>
        <div>
          <img src={blog2} alt="Blog1-2nd image" className="blog1-2" />
        </div>
      </div>
    </div>
  );
}

export default Blog3;
